<div *ngIf="item.immoTask.description?.length > 0" class="flex-row">
  <mat-card class="summary-card info">
    <div class="flex-row">
      <span class="preserve-new-line">
        {{ item.immoTask.description }}
      </span>
    </div>
  </mat-card>
  <mat-card class="mat-elevation-z0 summary-card progress">
    <mat-checkbox
      [disabled]="finishDisabled"
      [ngModel]="item.immoTask.atelierCheckboxes.descriptionRead"
      (ngModelChange)="markDescriptionRead($event)"
    >
      Gelezen
    </mat-checkbox>
  </mat-card>
</div>

<div class="flex-row">
  <mat-card class="mat-elevation-z0 summary-card info">
    <div class="flex-row">
      <div class="inner-info">
        <div class="task-info">
          <div>
            <div class="strong">{{ item.immoTask.subject }}</div>
            <div
              *ngIf="item.immoTask.atelierInfo?.length > 0"
              class="highlighted preserve-new-line"
            >
              {{ item.immoTask.atelierInfo }}
            </div>
          </div>
          <div
            *ngIf="item.immoTask.address?.length > 0"
            class="address-display"
          >
            {{ item.immoTask.address }}
          </div>
        </div>
      </div>
      <div class="inner-picture">
        <div
          *ngIf="item.immoTask.firstDesignPicture?.uuid?.length > 0"
          class="mb-2"
        >
          <img
            class="pointer mb-2"
            [src]="'/api/assets/' + item.immoTask.firstDesignPicture.uuid"
            (click)="openLightbox()"
          />
        </div>
      </div>
    </div>
  </mat-card>

  <mat-card class="mat-elevation-z0 summary-card progress">
    <mat-checkbox
      [disabled]="finishDisabled"
      [ngModel]="item.immoTask.atelierCheckboxes.prepared"
      (ngModelChange)="markPrepared($event)"
    >
      Klaargezet
    </mat-checkbox>
  </mat-card>
</div>

<div class="flex-row">
  <div class="review-placeholder"></div>
  <mat-card class="summary-card progress">
    <mat-checkbox
      [disabled]="reviewDisabled"
      [ngModel]="item.immoTask.atelierCheckboxes.reviewed"
      (ngModelChange)="markReviewed($event)"
    >
      Gecontroleerd
    </mat-checkbox>
  </mat-card>
</div>
